import Super from './super'
import Link from './link'
import Caption from './caption'
import BlockQuote from './blockquote'
import UnstyledList from './unstyled-list'
import UnstyledLink from './unstyled-link'

export * from './headings'
export * from './body'
export * from './endnotes'
export { Super, Link, Caption, BlockQuote, UnstyledList, UnstyledLink }



// WEBPACK FOOTER //
// ./src/components/typography/index.js